// Module
var code = "<div>\n    <sales-comparison-view></sales-comparison-view>\n</div>\n";
// Exports
module.exports = code;